export const SET_ALERT = "SET_ALERT";
export const REMOVE_ALERT = "REMOVE_ALERT";

export const USER_LOADED = "USER_LOADED";
export const AUTH_ERROR = "AUTH_ERROR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";

export const ADMINS_AUTH = "ADMINS_AUTH";
export const GET_ALL_ADMINS = "GET_ALL_ADMINS";
export const ADD_ADMIN = "ADD_ADMIN";
export const UPDATE_ADMIN = "UPDATE_ADMIN";
export const DELETE_ADMIN = "DELETE_ADMIN";
export const ERR_ADMIN = "ERR_ADMIN";

export const POLLS_AUTH = "POLLS_AUTH";
export const GET_ALL_POLLS = "GET_ALL_POLLS";
export const ADD_POLL = "ADD_POLL";
export const UPDATE_POLL = "UPDATE_POLL";
export const DELETE_POLL = "DELETE_POLL";
export const ERR_POLL = "ERR_POLL";
//  For SEO
export const ADD_SEO_POLL = "ADD_SEO_POLL";
export const UPDATE_SEO_POLL = "UPDATE_SEO_POLL";
// reporting_dashboard
export const GET__HIGEST_POLL = "GET__HIGEST_POLL";
export const LOADING__HIGEST_POLL = "LOADING__GET__HIGEST_POLL";
export const ERR__HIGEST_POLL = "ERR__GET__HIGEST_POLL";
export const GET_POLL_ANALYSIS = "GET_POLL_ANALYSIS";
export const POLL_RESULT_CLEAR = "POLL_RESULT_CLEAR";
export const LOADING__POLL_ANALYSIS = "LOADING__GET__POLL_ANALYSIS";
export const ERR__GET__POLL_ANALYSIS = "ERR__GET__POLL_ANALYSIS";

export const GET__REFERRALS = "GET__REFERRALS";
export const LOADING__REFERRALS = "LOADING__REFERRALS";
export const ERR__REFERRALS = "ERR__REFERRALS";

//  For Poll Bharat
export const GET_BHARAT_STATES = "GET_BHARAT_STATES";
export const GET_BHARAT_CONSTITUENCY = "GET_BHARAT_CONSTITUENCY";
export const GET_BHARAT_MP = "GET_BHARAT_MP";
export const ERR_BHARAT_POLL = "ERR_BHARAT_POLL";

// For Poll option img upload
export const OPTIONS_LOADING = "OPTIONS_LOADING";
export const OPTIONS_DATA = "OPTIONS_DATA";
export const OPTIONS_ERROR = "OPTIONS_ERROR";
export const OPTIONS_DELETE = "OPTIONS_DELETE";
export const OPTIONS_CLEAR_ALL = "OPTIONS_CLEAR_ALL";
